export default __webpack_public_path__ + "static/13_36-97a8da90eeefbc21e0fc281aa7f11ccb.png";